class VersionCheck {
    check(needVersion, hasVersion) {
        const splitNeedVersion = needVersion.split(".");
        const splitHasVersion = hasVersion.split(".");
        let retVal = false;
        for (let i = 0; i < splitNeedVersion.length; i++) {
            const partNeedVersion = parseInt(splitNeedVersion[i] || 0);
            const partHasVersion = parseInt(splitHasVersion[i] || 0);
            if (partHasVersion > partNeedVersion) {
                retVal = true;
                break;
            } else if (partHasVersion === partNeedVersion) {
                retVal = true;
            } else {
                retVal = false;
                break;
            }
        }
        return retVal;
    }
}

export default new VersionCheck();